import { FC, useState } from 'react'
import Button from 'components/ui/Button'
import TextField from 'components/ui/TextField'
import { IFormProps } from './interfaces'
import { Link } from 'react-router-dom'
import * as Styles from './Forms.styles'
import Checkbox from '@mui/material/Checkbox'

const SignupForm: FC<IFormProps> = ({
  formId,
  title,
  buttonText,
  handleSubmit,
  isLoading = false,
  isError = false
}) => {
  const [agreeTerms, setAgreeTerms] = useState(false)

  const handleAgreeTerms = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAgreeTerms(event.target.checked)
  }

  return (
    <div data-testid={formId}>
      <Styles.Title data-testid={`${formId}-title`}>{title}</Styles.Title>
      <Styles.Form onSubmit={(event) => handleSubmit(event)}>
        <TextField id="name" label="Name" cc-width="full" required autoFocus />
        <TextField
          id="email"
          label="Email"
          type={'email'}
          cc-width="full"
          required
        />
        <TextField
          id="password"
          label="Password"
          type={'password'}
          cc-width="full"
          helperText="Password must contain at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character."
          required
        />
        <Button
          loading={isLoading}
          disabled={!agreeTerms || isError || isLoading}
          data-testid={`${formId}-submit-button`}
          type="submit"
          cc-color="purple"
          cc-width="full"
        >
          {buttonText}
        </Button>
      </Styles.Form>
      {isError ? (
        <Styles.Footer className="!text-red-500">
          Unable to find that merchant Name
        </Styles.Footer>
      ) : (
        <>
          <Styles.Footer className="items-center">
            <Checkbox
              checked={agreeTerms}
              onChange={handleAgreeTerms}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <div>
              I agree to the{' '}
              <Styles.FooterLink>
                <Link
                  target="_blank"
                  to={`https://surefirecpr.com/privacy-policy/`}
                >
                  Privacy Policy
                </Link>
              </Styles.FooterLink>
            </div>
          </Styles.Footer>
          <Styles.Footer>
            Already have an account?{' '}
            <Styles.FooterLink>
              <Link to={`/`}>Log in</Link>
            </Styles.FooterLink>
          </Styles.Footer>
        </>
      )}
    </div>
  )
}

export default SignupForm
